const LICENSE_EXPIRATION_WARNING_THRESHOLD_DAYS = 7;

export const isAboutToExpire = (days: number): boolean => days <= LICENSE_EXPIRATION_WARNING_THRESHOLD_DAYS;
